@if (equipment) {
    <div class="has-text-centered has-text-left">
        <h3 class="title is-level-5">Mon équipement</h3>
        <div class="columns is-marginless is-mobile pt-1 is-aligned-center">
            <div class="column is-narrow">
                <picture>
                    <img
                        [defaultImage]="defaultImage"
                        [lazyLoad]="images"
                        [useSrcset]="true"
                        alt="{{ equipment?.data.title }}"
                        class="fai-image"
                    />
                </picture>
            </div>
            <div class="column pl-0">
                <p class="text is-level-2">{{ description }}</p>
            </div>
        </div>
    </div>
}
